import React, { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import "./Login_Modal.css";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import PasswordChecklist from "react-password-checklist";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Reset_Password_Modal from "../reset_password_modal/Reset_Password_Modal";
import Black_Btn from "../../common_btn/black_btn/Black_Btn";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import Success_Modal from "../success_modal/Success_Modal";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { UserLogin, userSignUp } from "../../../../features/auth/authSlice";
import { getAllCart } from "../../../../features/cart/cartSlice";
import { myAccount } from "../../../../features/my_account/Slice";
import { text } from "@fortawesome/fontawesome-svg-core";
import SingUp_Modal from "./Singup_Modal";

const Login_Modal = (props) => {
  const {
    control,
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm();

  

  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  const navigate = useNavigate();

  const [showSignUp, setShowSignUp] = useState(false);

  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };

  const dispatch = useDispatch();
  const isSignin = useSelector((state) => state.auth.is_signin);

 
  const onLogin = async (data) => {
    const res = await dispatch(UserLogin(data));

    if (res.meta?.requestStatus === "fulfilled") {
      props?.onHide();
      props?.loginDone();
      setSuccessMsg("Login Succesfully !");
      setShowSucsessModal(true);
      setTimeout(() => {
        setShowSucsessModal(false);
        // navigate("/")
      }, 3000);
      dispatch(getAllCart(isSignin));
    } else if (res.meta?.requestStatus === "rejected") {
      if (res.payload?.errors?.email) {
        setError("email", {
          type: "manual",
          message: res.payload?.errors?.email,
        });
      }
      if (res.payload?.errors?.password) {
        setError("password", {
          type: "manual",
          message: res.payload?.errors?.password,
        });
      }
    }
  };

  const user = useSelector((state) => state.myaccount.addMyaccount);

  useEffect(() => {
    if (user?.id) {
      dispatch(myAccount());
    }
  }, []);

  return (
    <>
      <Modal className="Login_Modal" size="md" {...props} centered>
        <div className="absolute_div">
          <p className="modal_title">{showSignUp ? "SIGN UP" : "LOGIN"}</p>

          <div className="logo_holder">
            <img src="/assets/images/login/logo.png" className="logo_img" />
          </div>
        </div>

        <Modal.Body>
          <div className="close_img_div">
            <img
              src="/assets/images/login/close.png"
              className="close_img"
              onClick={() => {
                props?.onHide();
              }}
            />
          </div>

          {!showSignUp && (
            <div className="login_div">
              <div className="login_form_div">
                <Form>
                  <Form.Group className="gray_input_group input_group">
                    <Form.Label>Email / Mobile Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="email"
                      placeholder="Enter your email or mobile number"
                      {...register("email", {
                        required: "Email is required",
                      })}
                    />
                    {errors?.email && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors?.email?.message}
                      </div>
                    )}
                  </Form.Group>

                  <Form.Group className="gray_input_group input_group">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Password"
                      {...register("password", {
                        required: "Password is required",
                      })}
                    />
                    {errors.password && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors.password.message}
                      </div>
                    )}
                    <p
                      className="link_text dark_text"
                      onClick={() => {
                        props?.onHide();
                        props?.setShowResetModal();
                      }}
                    >
                      Forgot Password?
                    </p>
                  </Form.Group>
                </Form>
              </div>
              <div className="btn_holder">
                <Black_Btn btnText="Login" onClick={handleSubmit(onLogin)} />
              </div>

              <p className="dark_text">
                Don't have an account?{" "}
                <span
                  className="link_text"
                  onClick={() => {
                    setShowSignUp(true);
                  }}
                >
                  Create Account
                </span>
                .
              </p>

              {/* <div className='or_text_div'>
                                <p className='or_txt'>Or</p>
                            </div>

                            <div className='google_img_holder'>
                                <div className='img_holder'>
                                    <img src='/assets/images/login/google.png' className='g_img' />
                                </div>
                                <p className='signu_with_g_txt'>Sign Up with Google</p>
                            </div> */}
            </div>
          )}

          {showSignUp && (
            <SingUp_Modal
              setShowSignUp={setShowSignUp}
              showSignUp={showSignUp}
              setShowAccountCreted={props?.setShowAccountCreted}
              onHide={props?.onHide}
            />

            // <div className="signup_div">
            //   <div className="login_form_div">
            //     <Form>
            //       <div className="row">
            //         <div className="col-md-6">
            //           <Form.Group className="gray_input_group input_group">
            //             <Form.Label>First Name</Form.Label>
            //             <Form.Control
            //               type="text"
            //               placeholder="Enter First name"
            //               {...register("Name", {
            //                 required: "Name is required",
            //               })}
            //             />
            //             {errors?.Name && (
            //               <div style={{ fontSize: "13px", color: "red" }}>
            //                 {errors?.Name?.message}
            //               </div>
            //             )}
            //           </Form.Group>
            //         </div>
            //         <div className="col-md-6">
            //           <Form.Group className="gray_input_group input_group">
            //             <Form.Label>Last Name</Form.Label>
            //             <Form.Control
            //               type="text"
            //               placeholder="Enter Last name"
            //               {...register("LastNamel", {
            //                 required: "Last Name is required",
            //               })}
            //             />
            //             {errors.LastNamel && (
            //               <div style={{ fontSize: "13px", color: "red" }}>
            //                 {errors?.LastNamel?.message}
            //               </div>
            //             )}
            //           </Form.Group>
            //         </div>
            //       </div>

            //       <Form.Group className="gray_input_group input_group">
            //         <Form.Label>Email ID</Form.Label>
            //         <Form.Control
            //           type="text"
            //           placeholder="Enter your email "
            //           {...register("email", {
            //             required: "Email is required",
            //             pattern: {
            //               value: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
            //               message: "Email Address Invalid",
            //             },
            //           })}
            //         />
            //         {errors?.email && (
            //           <sup className="text-danger">
            //             {errors?.email?.message}
            //           </sup>
            //         )}
            //       </Form.Group>

            //       <Form.Group className="gray_input_group input_group">
            //         <Form.Label className="label_text">Password</Form.Label>
            //         <div className="password_holder">
            //           <Form.Control
            //             type={showPassword ? "text" : "password"}
            //             name="password"
            //             placeholder="Enter Password"
            //             {...register("password", {
            //               required: "Password is required",
            //               minLength: {
            //                 value: 8,
            //                 message:
            //                   "Password must be at least 8 characters long",
            //               },
            //               pattern: {
            //                 value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
            //                 message:
            //                   "Password must contain at least one uppercase letter, one lowercase letter, and one number",
            //               },
            //             })}
            //             onChange={(e) => setPassword(e.target.value)}
            //           />
            //           {errors?.password && (
            //             <sup className="text-danger">
            //               {errors?.password?.message}
            //             </sup>
            //           )}
            //           <div className="eye-icc">
            //             <FontAwesomeIcon
            //               icon={iconOne}
            //               className="icon"
            //               onClick={() => togglePasswordVisibility("password")}
            //             />
            //           </div>
            //         </div>
            //       </Form.Group>

            //       <Form.Group className="gray_input_group input_group">
            //         <Form.Label className="label_text">
            //           Confirm Password
            //         </Form.Label>
            //         <div className="password_holder">
            //           <Form.Control
            //             placeholder="Confirm Password"
            //             type={showPasswordOne ? "text" : "password"}
            //             name="re_password"
            //             {...register("re_password", {
            //               required: "Re-Enter Password  is required",
            //             })}
            //             onChange={(e) => setPasswordAgain(e.target.value)}
            //           />

            //           <div className="eye-icc">
            //             <FontAwesomeIcon
            //               icon={iconTwo}
            //               className="icon"
            //               onClick={() =>
            //                 togglePasswordVisibility("reenterPassword")
            //               }
            //             />
            //           </div>
            //           {errors?.re_password && (
            //             <sup className="text-danger">
            //               {errors?.re_password?.message}
            //             </sup>
            //           )}
            //         </div>
            //       </Form.Group>

            //       {password && (
            //         <div className="password_check_list">
            //           <PasswordChecklist
            //             rules={[
            //               "minLength",
            //               "specialChar",
            //               "number",
            //               "capital",
            //               "match",
            //             ]}
            //             minLength={8}
            //             value={password}
            //             valueAgain={passwordAgain}
            //             onChange={(isValid) => {}}
            //             style={{
            //               fontSize: "10px",
            //               padding: "4px",
            //               margin: "0",
            //             }}
            //           />
            //         </div>
            //       )}

            //       <div className="row mt-2">
            //         <div className="col-sm-6">
            //           <Form.Group className="gray_input_group input_group">
            //             <Form.Label>Contact</Form.Label>
            //             <Controller
            //               country="in"
            //               className="phone_input"
            //               name="contact_no"
            //               control={control}
            //               rules={{
            //                 required: "contact_no is required",
            //                 minLength: {
            //                   value: 10,
            //                   message:
            //                     "Number should be at least 10 characters",
            //                 },
            //               }}
            //               render={({ field }) => (
            //                 <PhoneInput
            //                   country="in"
            //                   {...field}
            //                   onChange={(value) => field.onChange(value)}
            //                   type="text"
            //                   placeholder="Enter Mobile Number"
            //                   maxLength={10}
            //                 />
            //               )}
            //             />
            //             {errors?.contact_no && (
            //               <sup className="text-danger">
            //                 {errors?.contact_no?.message}
            //               </sup>
            //             )}
            //           </Form.Group>
            //         </div>

            //         <div className="col-sm-6">
            //           <Form.Group className="gray_input_group input_group">
            //             <Form.Label>Date of Birth</Form.Label>
            //             <Form.Control
            //               type="date"
            //               max={new Date().toISOString().split("T")[0]} // disable future dates
            //               {...register("date", {
            //                 required: "Date of birth is required",
            //                 validate: {
            //                   notFuture: (value) =>
            //                     new Date(value) <= new Date() ||
            //                     "Future date not allowed",
            //                 },
            //               })}
            //             />
            //             {errors?.date && (
            //               <div style={{ fontSize: "13px", color: "red" }}>
            //                 {errors?.date?.message}
            //               </div>
            //             )}
            //           </Form.Group>
            //         </div>
            //       </div>
            //     </Form>
            //   </div>

            //   <div className="btn_holder">
            //     <Black_Btn btnText="Sign Up" onClick={handleSubmit(onSubmit)} />
            //   </div>

            //   <p className="dark_text">
            //     Already have an account?{" "}
            //     <span
            //       className="link_text"
            //       onClick={() => {
            //         setShowSignUp(false);
            //       }}
            //     >
            //       Log In
            //     </span>
            //     .
            //   </p>

            // </div>
          )}
        </Modal.Body>
      </Modal>

      <Success_Modal
        show={showSuccessModal}
        onHide={() => {
          setShowSucsessModal(false);
        }}
        successText={successMsg}
      />
    </>
  );
};

export default Login_Modal;
